import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';
import { getUserPlanPaymentHistoryList } from "../../utils/customerApi";

export default function Billing() {
    const [isLoading, setIsLoading] = useState(true);
    const [billingData, setBillingData] = useState(null);  

    // Fetch user billing data
    const fetchBillingData = async () => {
        setIsLoading(true);
        try {
            const result = await getUserPlanPaymentHistoryList();
            if (result && result.data) {
                setBillingData(result.data);
            }
        } catch (error) {
            //console.error("Error fetching billing data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBillingData();
    }, []);

    return (
        <div className="container-scroller">
            <SideBar />
            <div className="main-panel">
                <div className="content-wrapper">
                    <HeaderSection />
                    <div className="my-profile-saction">
                        <div className="my-profile-saction-inner">
                            <h2>Billing</h2>
                            {isLoading ? (
                                <div className="loader-container">
                                    <div className="spinner"></div>
                                    <p>Loading, please wait...</p>
                                </div>
                            ) : billingData && billingData.length > 0 ? (
                                <>
                                    <h3>Active Subscriptions</h3>
                                    <div className="billing-row-one">
                                        <div className="billing-row-one-left">
                                            <span>All Apps Pro Pack (Yearly)</span>
                                            <p>Next payment: $360 on Jan 9, 2026</p>
                                        </div>
                                        <div className="billing-row-one-right">
                                            <button className="change-plan-btn"><Link to="/customer/apps/google-reviews/pricing/single">Change Plan</Link></button>
                                            <button className="button-dot">
                                                <img src={`${process.env.PUBLIC_URL}/images/icon-6.png`} alt="Options" />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Payment History */}
                                    <div className="billing-row-tow">
                                        <h3>Payment History</h3>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Description</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {billingData.map((payment, index) => (
                                                    <tr key={index}>
                                                        <td>{payment.created_at ? `${format(parseISO(payment.created_at), "MMM d, yyyy")}` : ""}</td>
                                                        <td>{payment.description}</td>
                                                        <td>${payment.amount}</td>
                                                        <td className={payment.payment_status === "Failure" ? "payment-failed" : ""}>
                                                            {payment.payment_status === "Failure" ? "Payment Failed" : "View Invoice"}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <h3>Active Subscriptions</h3>
                                    <p>You don’t have any active subscription.<br />
                                        As soon as you subscribe, you will be able to manage your subscriptions and payments here.
                                    </p>
                                    <Link 
                                        to="/customer/apps/google-reviews/pricing/single"
                                        className="btn btn-warning px-3 py-1 fw-semibold rounded-pill shadow-sm border-0 mt-3"
                                        style={{
                                            backgroundColor: '#f9c100',
                                            color: '#000',
                                            fontSize: '14px',
                                        }}
                                        >
                                        <i className="bi bi-cart-fill me-2"></i> Buy Plan
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
